import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { usePaymentFlow } from './hooks/usePaymentFlow';
import PaymentLayout from './components/PaymentLayout';
import PaymentOptions from './components/PaymentOptions';
import ActionButtons from './components/ActionButtons';
import ErrorDisplay from './components/ErrorDisplay';
import { identityAuthorized } from '../../../utils/api/restClient';
import { useState, useEffect } from 'react';
import { Loading } from './components/Loading';
import useAuth from '../../../hooks/useAuth';
import { useRequireAuthorization } from './hooks/useRequireAuthorization';
import './styles.scss';

function PaymentSelectionPage() {
  const { isAuthed } = useAuth();
  const navigate = useNavigate();
  const basket = useSelector(state => state.Order.basket);
  const project = useSelector(state => state.Project.project);
  const selectedOption = useSelector(state => state.Payment.selected_payment_option);
  const [loading, setLoading] = useState(false);
  const {
    handlePayment,
    isProcessing,
    error,
    resetError
  } = usePaymentFlow({ project, basket });


  // 1. Redirect to login if user is unauthorized. TODO: This should be moved to /slug page for better user experience
  useRequireAuthorization(identityAuthorized, setLoading);


  // 2. Redirect to / if project or basket is invalid
  useEffect(() => {
    if (!project) {
      navigate('/');
      return;
    }
    if (basket.total === 0 || !basket.basketValid || !basket.phoneValid) {
      if (project.slug) {
        navigate(`/${project.slug}`);
      } else {
        navigate('/');
      }
      return;
    }
  }, [basket, project, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  });


  if (basket.total === 0 || !basket.basketValid || !basket.phoneValid) {
    return null;
  }
  if (loading) {
    return <Loading  />;
  }
  if (error) {
    return (
      <ErrorDisplay
        onRetry={() => {
          resetError();
          handlePayment(selectedOption);
        }}
        onChangeOption={resetError}
      />
    );
  }
  return (
    <PaymentLayout isAuthed={isAuthed()}>
      <PaymentOptions
        selectedOption={selectedOption}
        availableOptions={project?.paymentOptions}
      />
      <ActionButtons
        onProceed={() => handlePayment(selectedOption)}
        onCancel={() => navigate(`/${project.slug}`)}
        isProcessing={isProcessing}
        total={basket.total}
        currency={project.currency}
      />
    </PaymentLayout>
  );
}

export default PaymentSelectionPage;